import React, { type FC } from 'react'

interface IconMobileProps {
  width?: string
  height?: string
}

const IconMobile: FC<IconMobileProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 18"
      fill="none"
    >
      <path
        fill="currentColor"
        shapeRendering="geometricPrecision"
        d="M2.25 15.75C2.25 16.0594 2.50312 16.3125 2.8125 16.3125H10.6875C10.9969 16.3125 11.25 16.0594 11.25 15.75V12.9375H2.25V15.75ZM2.25 11.25H11.25V2.25C11.25 1.94062 10.9969 1.6875 10.6875 1.6875H2.8125C2.50312 1.6875 2.25 1.94062 2.25 2.25V11.25ZM0.5625 2.25C0.5625 1.00898 1.57148 0 2.8125 0H10.6875C11.9285 0 12.9375 1.00898 12.9375 2.25V15.75C12.9375 16.991 11.9285 18 10.6875 18H2.8125C1.57148 18 0.5625 16.991 0.5625 15.75V2.25ZM5.625 14.0625H7.875C8.18437 14.0625 8.4375 14.3156 8.4375 14.625C8.4375 14.9344 8.18437 15.1875 7.875 15.1875H5.625C5.31563 15.1875 5.0625 14.9344 5.0625 14.625C5.0625 14.3156 5.31563 14.0625 5.625 14.0625Z"
      />
    </svg>
  )
}

export default IconMobile
